import React from "react"

import { WithClassName } from "shared/types/WithClassName"

import { useProjectTeamInvitationListViewModel } from "./model/useProjectTeamInvitationListViewModel"
import { ProjectTeamInvitationListModel } from "./types/ProjectTeamInvitationListModel"
import { ProjectTeamInvitationListView } from "./ui/ProjectTeamInvitationListView"

export interface ProjectTeamInvitationListProps
  extends ProjectTeamInvitationListModel,
    WithClassName {}

export const ProjectTeamInvitationList = React.memo(
  (props: ProjectTeamInvitationListProps) => {
    return (
      <ProjectTeamInvitationListView
        {...useProjectTeamInvitationListViewModel(props)}
      />
    )
  }
)
